// Helpers to build stable, router-safe URLs for college pages.
// We intentionally remove/normalize characters like '/' so they don't create extra path segments.

export const slugifyPathSegment = (value) => {
  if (value === null || value === undefined) return "";
  return String(value)
    .toLowerCase()
    .trim()
    .replace(/['’]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-|-$/g, "");
};

export const toCollegeDetailsPath = (collegeName, city, id) => {
  const namePart = slugifyPathSegment(collegeName || "college");
  const cityPart = slugifyPathSegment(city || "city");
  const idPart = slugifyPathSegment(id || "0");

  return `/college/${namePart}-${cityPart}-${idPart}`;
};
